import React from 'react'

import { PasswordValidationContainer } from './styled'
import Check from '../Check'
import useI18n from 'hooks/useI18n'


export default function PasswordValidation({ password, row }) {
    const { t } = useI18n()
    return (
        <>
            <PasswordValidationContainer row={row}>
                <Check checked={password?.match(/[A-Z]/)} label={t('one_uppercase_letter')} />
                <Check checked={password?.match(/[0-9]/)} label={t('one_number')} />
                <Check checked={password?.length > 5} label={t('at_least_6_characters')} />
                <Check checked={password?.match(/[!@#$%^&*()\-\+=\{\}\[\]\\|;:,.\/?'\"~<>`´]/)} label={t('at_least_1_special_character')} />
            </PasswordValidationContainer>
        </>
    )
}